import { t } from 'i18next';
import { BRAZILIAN_STATES } from 'utils/old-ui-commons/constants';
import { runSchemaValidator } from 'utils/old-ui-commons/form';
import { isPostalCode } from 'utils/old-ui-commons/validations';

export const FIELD_NAMES = {
  postalCode: 'postal_code',
  street: 'street',
  toggleAddressNumber: 'toggleAddressNumber',
  number: 'number',
  complement: 'complement',
  city: 'city',
  neighbourhood: 'neighbourhood',
  state: 'state',
};

export const BR_STATE_OPTIONS = Object.keys(BRAZILIAN_STATES).map((uf) => ({
  label: BRAZILIAN_STATES[uf],
  value: uf,
}));

export const formValidate = (values) => {
  const trustyValueValidator = {
    message: t`please fill in this field`,
    validate: (value) => value,
  };

  const trustyNumberValidator = {
    message: t`please fill in this field`,
    validate: () => !(!values.toggleAddressNumber && !values.number),
  };

  return runSchemaValidator(
    {
      [FIELD_NAMES.postalCode]: [
        { message: t`invalid format`, validate: (value) => isPostalCode(value) },
      ],
      [FIELD_NAMES.street]: [trustyValueValidator],
      [FIELD_NAMES.neighbourhood]: [trustyValueValidator],
      [FIELD_NAMES.number]: [trustyNumberValidator],
      [FIELD_NAMES.toggleAddressNumber]: [trustyNumberValidator],
      [FIELD_NAMES.city]: [trustyValueValidator],
      [FIELD_NAMES.state]: [trustyValueValidator],
    },
    values
  );
};
